module.exports = __webpack_public_path__ + "static/media/7.213ecb33.png";